window.dataLayer = window.dataLayer || []

const pushAnalytics = (data) => {
	data.game = data.game || 'nw'
	data.source = data.source || 'nw_microsite'
	data.event = data.event || 'nw_microsite_interaction'
	window.dataLayer.push(data)
}

const trackHo = ({ ref }) => {
	if (!navigator.sendBeacon) {
		return
	}
	navigator.sendBeacon('/analytics/track', JSON.stringify({ ref }))
	return
}

export { pushAnalytics, trackHo }
